import useDeviceSize from '@/hooks/useDeviceSize';
import './portfolio-font.scss';
import { PortfolioDetailData } from '@/data/portfolio/portfolio-detail-data';
import { motion, useInView } from 'motion/react';
import { useRef } from 'react';

type Props = {
	font: PortfolioDetailData['font'];
};

const PortfolioFont = ({ font }: Props) => {
	const { deviceSize } = useDeviceSize();
	const ref = useRef<HTMLDivElement>(null);
	const inView = useInView(ref, { once: true, margin: '0px 0px -300px 0px' });

	const { kr, en } = font;

	const KrFont = kr[deviceSize];
	const EnFont = en[deviceSize];

	return (
		<div className="portfolio-font-wrapper" ref={ref}>
			<motion.section
				className="title-section"
				initial={{ opacity: 0, y: 50 }}
				animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
				transition={{ duration: 0.8, ease: 'easeOut' }}
			>
				<h1>Design System</h1>
				<h4>디자인 시스템</h4>
			</motion.section>
			<section className="font-section">
				<motion.div
					className="kr-font"
					initial={{ opacity: 0, y: 50 }}
					animate={
						inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }
					}
					transition={{
						duration: 0.8,
						ease: 'easeOut',
						delay: 0.4
					}}
				>
					<KrFont />
				</motion.div>
				<motion.div
					className="en-font"
					initial={{ opacity: 0, y: 50 }}
					animate={
						inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }
					}
					transition={{
						duration: 0.8,
						ease: 'easeOut',
						delay: 0.7
					}}
				>
					<EnFont />
				</motion.div>
			</section>
		</div>
	);
};

export default PortfolioFont;
